module.exports = __webpack_public_path__ + "static/img/kl1150-663-37073p.35285a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/kl1150-663-37073p.jpg
// module id = At6u
// module chunks = 0